/** @jsxImportSource react */
import { Box, Typography } from '@mui/material'

const EmptyState = ({ icon, title, description, action }) => (
  <Box sx={{ textAlign: 'center', py: 8, px: 2, color: 'text.secondary' }}>
    {icon && <Box sx={{ mb: 1.5, '& svg': { fontSize: 40, opacity: 0.6 } }}>{icon}</Box>}
    <Typography variant="h6" color="text.primary" gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ maxWidth: 420, mx: 'auto', mb: action ? 2.5 : 0 }}>
        {description}
      </Typography>
    )}
    {action}
  </Box>
)

export default EmptyState
